// extracted by mini-css-extract-plugin
module.exports = {"DeleteLink":"TodoTemplateListRow_DeleteLink__EGKai","DropdownMenuIcon":"TodoTemplateListRow_DropdownMenuIcon__fLGCx"};